<form role="form" class="form-horizontal">
	<div class="form-group">
		<label class="col-md-1 plus-half control-label" for="dateDebut">Entre le</label>
		<div class="col-md-2">
			<date-input
				[id]="'inputFiltreDateDebut'"
				[localDateMax]="filters.dateMax"
				[localDate]="filters.dateMin"
				(localDateChange)="onDateDebutChange($event)"
				>
			</date-input>
		</div>
		<label class="col-md-1 plus-half control-label" for="dateFin"> et le</label>
		<div class="col-md-2">
			<date-input
				[id]="'inputFiltreDateFin'"
				[localDateMin]="filters.dateMin"
				[localDate]="filters.dateMax"
				(localDateChange)="onDateFinChange($event)"
				>
			</date-input>
		</div>
	</div>
	<div class="form-group">
		<agence-filterable-selector
			[id]="'inputFiltreAgence'"
			[disabled]="userIsExp"
			[labelClass]="'col-md-1 plus-half'"
			[fieldClass]="'col-md-2 plus-half'"
			[selectedAgenceId]="filters.agenceId"
			(selectedAgenceChange)="onAgenceChange($event)"
			>
		</agence-filterable-selector>
		<antenne-filterable-selector
			[id]="'inputFiltreAntenne'"
			[disabled]="userIsExp"
			[labelClass]="'col-md-1'"
			[fieldClass]="'col-md-2 plus-half'"
			[agenceId]="filters.agenceId"
			[selectedAntenneId]="filters.antenneId"
			(selectedAntenneChange)="onAntenneChange($event)"
			>
		</antenne-filterable-selector>
		<parc-filterable-selector
			[id]="'inputFiltreParc'"
			[labelClass]="'col-md-1'"
			[fieldClass]="'col-md-2 plus-half'"
			[antenneId]="filters.antenneId"
			[selectedParcId]="filters.parcId"
			(selectedParcChange)="onParcChange($event)"
			>
		</parc-filterable-selector>
	</div>
	<div class="form-group">
		<emetteur-checkbox-list
			[id]="'inputFiltreER'"
			[labelClass]="'col-md-1 plus-half'"
			[fieldClass]="'col-md-2 plus-half'"
			[resetCommands]="resetCommands"
			(selectionIdsChange)="onSelectedERChange($event)"
			>
		</emetteur-checkbox-list>
		<etat-parc-checkbox-list
			[id]="'inputFiltreER'"
			[labelClass]="'col-md-1'"
			[fieldClass]="'col-md-2 plus-half'"
			[resetCommands]="resetCommands"
			(selectionIdsChange)="onSelectedEtatParcChange($event)"
			>
		</etat-parc-checkbox-list>
	</div>
	<div class="form-group">
		<div class="col-sm-12 text-right">
			<button type="button" class="btn btn-success" (click)="search()">Filtrer</button>
			&nbsp;
			<button type="button" class="btn btn-primary" (click)="resetFilters()">R&eacute;initialiser</button>
		</div>
	</div>
</form>